<template>
    <div id="Wp_group_owner_app">
<!--        <van-sticky :style="{display: banner_display}">-->
<!--            <Wp_user_banner v-on:reload="reloadPage"></Wp_user_banner>-->
<!--        </van-sticky>-->

        <div>
<!--            <keep-alive>-->
<!--                <transition name="component-fade" mode="out-in">-->
<!--                    <router-view v-if="$route.meta.keepAlive" style="margin-bottom: 60px"/>-->
<!--                </transition>-->
<!--            </keep-alive>-->
            <transition name="component-fade" mode="out-in">
                <router-view style="margin-bottom: 60px"/>
            </transition>
        </div>

        <div v-if="showTab">
            <Wp_tabbar id="tab" ref="tabBar" :tabSelect="select" />
        </div>
        <div v-if="$common.isClient() && !$common.isClient_hm() && (!this.sub_path || this.sub_path.startsWith('home_'))">
            <Wp_tabbar_for_client></Wp_tabbar_for_client>
        </div>


        <van-popup v-model="showLogin" :close-on-click-overlay="false" position="bottom" :style="{ height: '100%' }">
            <div style="background-color: white">
                <Wp_login v-on:reload="reloadPage"></Wp_login>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Button} from 'iview';
    import Wp_tabbar from "@/components/custom/Wp_tabbar";
    import Wp_login from "../pages_childs/Wp_login";
    import Wp_tabbar_for_client from "../custom/Wp_tabbar_for_client";
    // import Wp_user_banner from "@/components/custom/Wp_user_banner";

    Vue.component('i-button', Button);

    export default {
        name: 'Wp_group_owner_app',
        components: {Wp_tabbar_for_client, Wp_login, Wp_tabbar},
        provide(){
            return{
                wp_group_owner_app : this
            }

        },
        data() {
            return {
                showLogin: false,
                isLogin: this.$store.getters.isLogin,
                test: false,

                banner_display: 'block',

                select: 0,
                select_add_tb: 1,
                select_add_pdd: 1,
                select_all_search: 1,

                showTab: true,

                sub_path: "",
            }
        },

        beforeCreate() {

        },

        created() {
            if (document.getElementById('loading')) {
                document.body.removeChild(document.getElementById('loading'));
            }

            this.sub_path = this.$common.getUrlKey("sub_path");

            // this.clearLoginDatas();

            let url = window.location.href;
            // this.$log("url = " + url)
            if(url.indexOf("/article/") !== -1){
                this.showLogin = false;
            }

            if(this.$config.project === 'hm'){
                this.showLogin = false;

                this.select_all_search = 0;
            }else{
                let that = this;
                this.$bus.$on('toLogin', (data) => {
                    this.$log(data);
                    that.showLogin = true
                });
            }
        },
        beforeDestroy() {
            this.$bus.$off('toLogin');
        },
        mounted() {
            // this.getGoodsDataNoParams();
            //添加滚动条的监听，用于判断显示"返回顶部"按钮
            // window.addEventListener('scroll', this.scrollListener);

            this.$wx.miniProgram.getEnv(res=>{

                if(res.miniprogram){
                    //在小程序中不弹出原有登录界面
                    this.showLogin = false;
                }
            });

        },
        //
        // destroyed() {
        //     window.removeEventListener('scroll', this.scrollListener);
        // },
        methods: {

            /**
             * 强制清理一次登录缓存
             */
            clearLoginDatas(){
                let host = window.location.host;
                if((host.indexOf("jd.wapg.cn") !== -1
                    || host.indexOf("localhost:8080") !== -1 || host.indexOf("192.168.") !== -1) && this.$config.project !== "mini" && this.$common.gloabl_wx_openid){
                    let clearTag = this.$store.state.isClearLoginData;
                    if(clearTag){
                        this.$store.commit('logout');
                        this.$emit('reload');
                        window.location.replace("/index.html");

                        this.$store.commit("setClearLoginTag", false);
                    }
                }
                // this.$store.commit("setClearLoginTag", true);

            },


            reloadPage() {
                window.location.reload();
            },

            // /**
            //  * 监听滚动条，判断显示"返回顶部"按钮
            //  */
            // scrollListener() {
            //     let topBtn = document.getElementById('to_top_button');
            //     //滚动条距离顶部距离
            //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            //     //窗口固定高度
            //     let browserHeight = window.outerHeight;
            //     if (scrollTop > browserHeight) {
            //         topBtn.style.display = 'block';
            //     } else {
            //         topBtn.style.display = 'none';
            //     }
            // },
            //
            // /**
            //  * 返回顶部
            //  */
            // toTop() {
            //     document.documentElement.scrollTop = document.body.scrollTop = 0;
            // }

            resetSelect(path) {
                // if(this.$common.canShowTaobao()){
                //     this.select_add_tb = 1;
                // }else{
                //     this.select_add_tb = 0;
                // }
                // if(this.$common.canShowPdd()){
                //     this.select_add_pdd = 1;
                // }else{
                //     this.select_add_pdd = 0;
                // }
                //
                // let add_temp = this.select_add_tb + this.select_add_pdd;
                let add_temp = this.select_all_search;

                let changelink_select = 1 + add_temp;
                let events_select = 2 + add_temp;
                let data_select = 2 + add_temp;
                let my_select = 3 + add_temp;
                let paydata_select = 3 + add_temp;
                if(path.indexOf('select') !== -1 && this.select !== 0){
                    this.select = 0;
                }
                if(this.$route.path.indexOf('all_search') !== -1 && this.select !== (0  + this.select_all_search)){
                    this.select = 0 + this.select_all_search;
                }
                // if(this.$route.path.indexOf('select_pdd') !== -1 && this.select !== (0  + this.select_add_pdd)){
                //     this.select = 0 + this.select_add_pdd;
                // }
                // if(this.$route.path.indexOf('select_tb') !== -1 && this.select !== (0  + add_temp)){
                //     this.select = 0 + add_temp;
                // }
                if(path.indexOf('changelink') !== -1 && this.select !== changelink_select){
                    this.select = changelink_select;
                }
                if(path.indexOf('events') !== -1 && this.select !== events_select){
                    this.select = events_select;
                }
                if (path.indexOf('data') !== -1 && this.select !== data_select) {
                    this.select = data_select;
                }
                if (path.indexOf('my') !== -1 && this.select !== my_select) {
                    this.select = my_select;
                }
                if (path.indexOf('paydata') !== -1 && this.select !== paydata_select) {
                    this.select = paydata_select;
                }

            },
        },

        watch: {
            $route(to, from) {
                this.$log("to = " + to.path);
                this.$log("from = " + from.path);
                this.resetSelect(to.path);
                if(from.path === "/sku_detail"){
                    this.$common.static_router_from_path = from.path;
                }

                if(to.path !== '/select'){
                    //只要离开select页面，就讲通用的颜色透明的标记置为false，这样返回select页面时，
                    // 传$common.transparent到Wp_search_model中后，才可触发watch
                    this.$common.transparent = false;
                }
            }
        }
    }
</script>

<style>
    #Wp_group_owner_app {
        font-family: Helvetica, Arial, sans-serif, verdana, tahoma, 'Avenir';
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active for below version 2.1.8 */
    {
        opacity: 0;
    }


    .layout {
        /*border: 1px solid #d7dde4;*/
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .layout-logo {
        width: 100px;
        /*height: 30px;*/
        background: #5b6270;
        border-radius: 3px;
        float: left;
        position: relative;
        top: 15px;
        left: 20px;
    }

    .layout-nav {
        width: 420px;
        margin: 0 auto;
        margin-right: 20px;
    }

    .ivu-layout {
        background: white;
    }

    .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ivu-modal {
        top: 0;
    }

</style>
